import Api from "../Api"

const getAll = async () => {

  try {
    const { data } = await Api.get('/empresas');
    return data;
  } catch (error) {
    console.log(error)
  }
}

const store = async (dataForm) => {

  try {
    const { data } = await Api.post('/empresas', dataForm);
    return data;
  } catch (error) {
    console.log(error)
  }
}

const storeEmpresaAgenda= async (idEmpresa,dataForm) => {

  try {
    const { data } = await Api.post('/empresas/'+idEmpresa+'/agendaOnline', dataForm);
    return data;
  } catch (error) {
    console.log(error)
  }
}

const getEmpresaAgenda= async (idEmpresa) => {

  try {
    const { data } = await Api.get('/empresas/'+idEmpresa+'/agendaOnline');
    return data;
  } catch (error) {
    console.log(error)
  }
}

export const EmpresasService = {
  getAll,
  store,
  storeEmpresaAgenda,
  getEmpresaAgenda
}